import React, { useState, useEffect } from "react";
import EditIcon from "assets/svgIcons/EditSqrIcon";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import SixDots from "assets/svgIcons/SixDot";
import { TableContainer } from "pages/Messages/VDU/VDUStyled";
import { StyledTable } from "assets/css/globle";
import { useDispatch, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { PopUpContainer } from "assets/css/globle";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
// global store imports from globalStore
import { useHookstate } from "@hookstate/core";
import {
  MESSAGE_VDU_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "../../../../globalStore/globalStore";
import { IconButton, Tooltip } from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly } from "constant";
import { uuid } from "_helperFunctions/uuid";

const PresetMessagesTable = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const [open, setOpen] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% - 40px)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };
  const { globalMessageVDU, globalIndexVDU, setSave } = useHookstate(
    MESSAGE_VDU_GLOBAL_STATE
  );

  const handelEditAlert = (item, index) => {
    globalMessageVDU.set(item);
    globalIndexVDU.set(index);
    setSave.set(false);
  };

  const handelDeleteButton = () => {
    let _VDUdata = JSON.parse(JSON.stringify(vduMessagesSettingData));
    let _VDUmessage = [..._VDUdata?.MessageInfo?.Messages.Message];
    _VDUmessage.splice(open.index, 1);
    _VDUdata.MessageInfo.Messages.Message = _VDUmessage;
    dispatch(
      COMMON_SERVICES.vduPutMessagesSettingServices(_VDUdata, siteId.get())
    ).then(() => {
      dispatch(COMMON_SERVICES.vduGetMessagesSettingServices(siteId.get()));
      setOpen(false);
    });
  };

  // data
  const dispatch = useDispatch();
  const { vduMessagesSettingData, getUserRole } =
    useSelector((state) => state.commonReducers) || [];
  const [vduMesg, setVduMesg] = useState(null);

  useEffect(() => {
    if (
      vduMessagesSettingData &&
      vduMessagesSettingData !== null &&
      vduMessagesSettingData !== undefined
    ) {
      setVduMesg(vduMessagesSettingData.MessageInfo?.Messages?.Message);
    }
  }, [vduMessagesSettingData]);
  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(vduMesg);
    let [source_data] = tempData.splice(e?.source?.index, 1);
    tempData.splice(e?.destination?.index, 0, source_data);
    setVduMesg(tempData);
    let payload = {
      ...vduMessagesSettingData,
      MessageInfo: {
        ...vduMessagesSettingData.MessageInfo,
        Messages: {
          ...vduMessagesSettingData.MessageInfo.Messages,
          Message: tempData,
        },
      },
    };

    dispatch(
      COMMON_SERVICES.vduPutMessagesSettingServices(
        payload,
        Number(siteId.get())
      )
    );
  };

  return (
    <TableContainer>
      <StyledTable>
        <DragDropContext onDragEnd={handleDragEnd}>
          <table>
            <tr className="table-head">
              <th style={{ width: "40px" }}></th>
              <th>{t("Text")}</th>
              <th>{t("Action")}</th>
            </tr>
            <Droppable droppableId="droppable-1">
              {(provider) => (
                <tbody ref={provider.innerRef} {...provider.droppableProps}>
                  {vduMesg && vduMesg !== null && vduMesg?.length !== 0 ? (
                    vduMesg?.map((item, index) => (
                      <Draggable
                        key={uuid()}
                        draggableId={item.$text}
                        index={index}
                      >
                        {(provider) => (
                          <tr
                            {...provider.draggableProps}
                            ref={provider.innerRef}
                            className="body"
                            key={item.$text}
                          >
                            <td {...provider.dragHandleProps}>
                              <SixDots className="display" />
                            </td>
                            <td>{item.$text}</td>
                            <td>
                              <div className="action-icon-btn">
                                <Tooltip title={t("Edit")} arrow>
                                  <IconButton
                                    disabled={
                                      isUserBasic(
                                        getUserRole && getUserRole?.Role
                                      ) ||
                                      isUserReadOnly(
                                        getUserRole && getUserRole?.Role
                                      )
                                    }
                                    onClick={() =>
                                      handelEditAlert(item.$text, index)
                                    }
                                  >
                                    <EditIcon
                                      color="#0009"
                                      width={20.19}
                                      height={20.19}
                                    />
                                  </IconButton>
                                </Tooltip>

                                <Tooltip title={t("Delete")} arrow>
                                  <IconButton
                                    disabled={
                                      isUserBasic(
                                        getUserRole && getUserRole?.Role
                                      ) ||
                                      isUserReadOnly(
                                        getUserRole && getUserRole?.Role
                                      )
                                    }
                                    onClick={() => setOpen({ index: index })}
                                  >
                                    <DeleteIcon
                                      color="#FA3C30"
                                      width={18.19}
                                      height={20.19}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            </td>
                          </tr>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <tr style={{ textAlign: "center", width: "100%" }}>
                      <td colSpan={5}>
                        <h3>{t("No_data")}</h3>
                      </td>
                    </tr>
                  )}
                  {provider.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </StyledTable>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Delete_this_message")}?</p>
            <div className="action-btn">
              <button onClick={() => handelDeleteButton()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => setOpen(null)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </TableContainer>
  );
};

export default PresetMessagesTable;
